export const messages = {
  en: {
    reportQuestionAnswerDetail: {
      queryCondition: 'Query Condition',
      selectQaType: 'Please select questionnaire type',
      pleaseSelect: 'Please select',
      ownerQuestionnaire: 'Owner Questionnaire',
      ownerVote: 'Owner Vote',
      staffVote: 'Staff Vote',
      selectStartTime: 'Please select start time',
      selectEndTime: 'Please select end time',
      query: 'Query',
      reset: 'Reset',
      questionnaireDetail: 'Questionnaire Detail Table',
      questionnaireAnswerDetail: 'Questionnaire answer details',
      export: 'Export',
      serialNumber: 'No.',
      questionnairePerson: 'Questionnaire Person',
      questionnaireType: 'Questionnaire Type',
      questionnaireName: 'Questionnaire Name',
      questionnaireQuestion: 'Questionnaire Question',
      answer: 'Answer',
      time: 'Time',
      endTimeMustGreater: 'End time must be greater than start time',
      fetchError: 'Failed to fetch questionnaire data',
      exportSuccess: 'Export success',
      exportError: 'Export failed'
    }
  },
  zh: {
    reportQuestionAnswerDetail: {
      queryCondition: '查询条件',
      selectQaType: '请选择问卷类型',
      pleaseSelect: '请选择',
      ownerQuestionnaire: '业主问卷',
      ownerVote: '业主投票',
      staffVote: '员工投票',
      selectStartTime: '请选择问卷开始时间',
      selectEndTime: '请选择问卷结束时间',
      query: '查询',
      reset: '重置',
      questionnaireDetail: '问卷明细表',
      questionnaireAnswerDetail: '问卷回答明细',
      export: '导出',
      serialNumber: '序号',
      questionnairePerson: '问卷人',
      questionnaireType: '问卷类型',
      questionnaireName: '问卷名称',
      questionnaireQuestion: '问卷题目',
      answer: '答案',
      time: '时间',
      endTimeMustGreater: '结束时间必须大于开始时间',
      fetchError: '获取问卷数据失败',
      exportSuccess: '导出成功',
      exportError: '导出失败'
    }
  }
}